export default __webpack_public_path__ + "static/media/DSC_0578.84fde885.jpg";